import { useEffect, useState } from "react";
import "./appListing.scss"
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";
import { Card } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import ScreenCard from "../components/screenCard/ScreenCard";
import CreateFlowDialog from "../components/dialog/CreateFlowDialog";
import Select from 'react-select'
import httpService from "../../../setup/http/httpServices";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Http2ServerRequest } from "http2";
const baseURL = process.env.REACT_APP_API_URL;

interface CardData {
    id: string;
    content: string;
    image: string;
}

const FlowManager = () => {
    const history: any = useHistory()
    const [createFlowDialogOpen, setCreateFlowDialogOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [selectedFlow, setSelectedFlow] = useState<string[]>([]);
    const [allFlow, setAllFlow] = useState([])
    const [flowDetail, setFlowDetail] = useState<any>([])
    const [isSuccess, setIsSuccess] = useState(false)

    const app_id = history.location.state?.edit ? history.location.state?.appListing?._id : history.location.state?.app_id;
    // console.log('flow app_id', history.location.state?.app_id)


    const handleScreenSelect = (id: string) => {
        const isSelected = selectedFlow.includes(id);
        if (isSelected) {
            setSelectedFlow(selectedFlow.filter(screenId => screenId !== id));
        } else {
            setSelectedFlow([...selectedFlow, id]);
        }
    };





    // GET FLOW BY CATEGORY ID
    const getFlowById = () => {
        if (selectedOption?.value !== undefined) {
            httpService.getData(
                `/flow/${selectedOption?.value}`,
                (res) => {
                    setFlowDetail(res.data?.flow?.screen_selected);
                    console.log('flow data by id', res?.data)
                    setIsSuccess(res.data?.success)
                },
                (err) => {
                    console.log('err', err);
                }
            );
        }
    };

    useEffect(() => {
        getFlowById();
    }, [selectedOption?.value]);


    const getFlows = () => {
        if (history.location.state?.edit) {
            setAllFlow(history.location.state?.appListing?.flows);
        }
    }

    useEffect(() => {
        httpService.getData(
            `/app/flows/${app_id}`,
            (res) => {
                setAllFlow(res.data?.data);
                // console.log('flow list', res?.data?.data)
            },
            (err) => {
                console.log('err', err);
            }
        );
        getFlows();
    }, [])


    // Set the default selected option to the first one
    useEffect(() => {
        if (allFlow.length > 0 && !selectedOption) {
            setSelectedOption({ value: allFlow[0]?._id, label: `${allFlow[0]?.category_id?.Name} (${allFlow[0]?.screen_selected?.length} screens)` });
        }
    }, [allFlow]);



    // Delete Screen Handler
    const deleteScreenHandler = () => {
        if (selectedFlow.length > 0) {
            axios.delete(
                `${baseURL}/flow/delete-flow`,
                {
                    headers: httpService.serviceHeader,
                    data: { ids: selectedFlow }
                }
            ).then((res) => {
                // console.log('unLink', res.data)
                getFlowById();
            }).catch((error) => {
                console.error('Error deleting screens:', error);
            });
        }
    };





    // Screen Details Popup
    const handleOpenCreateFlowDialog = () => {
        setCreateFlowDialogOpen(true);
    };
    const handleCloseCreateFlowDialog = () => {
        setCreateFlowDialogOpen(false);
    };






    const onDragEnd = async (result: DropResult) => {
        if (!result.destination) return;

        const newCards = Array.from<any>(flowDetail || []);
        const [reorderedCard] = newCards.splice(result.source.index, 1);
        newCards.splice(result.destination.index, 0, reorderedCard);

        setFlowDetail(newCards);

        try {
            await updateFlowPosition(reorderedCard?._id, result.destination.index + 1);
            // console.log('Flow position updated successfully!');
        } catch (error) {
            console.error('Error updating screen position:', error);
        }
    };

    const updateFlowPosition = async (screenId: string, newPosition: number) => {
        axios.patch(
            `${baseURL}/app/flow-position`,
            {
                headers: httpService.serviceHeader,
                appId: app_id,
                flowId: selectedOption?.value,
                screenId: screenId,
                newPosition: newPosition,

            }
        ).then((res) => {
            // console.log('updated flow position', res);
            getFlows();
        }).catch((error) => {
            console.error('Error deleting screens:', error);
        });

    };


    const handleChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };


    return (
        <>
            <div className="sreeen-header">
                <div className="left-box">
                    <h4 >Select Flow</h4>
                    <Select
                        options={allFlow?.map(item => ({ value: item?._id, label: `${item?.category_id?.Name} (${item?.screen_selected?.length} screens)` }))}
                        placeholder={`${allFlow?.length} flows available`}
                        className="text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-1 categorySelect"
                        styles={{
                            menuList: (provided, state) => ({
                                ...provided,
                                height: 'auto',
                                maxHeight: '200px',
                            }),
                        }}
                        value={selectedOption}
                        onChange={handleChange}
                        isSearchable
                    />
                </div>
                <div className="right-box">
                    <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn btn-primary'
                        onClick={() => {
                            history.push({
                                pathname: '/mobile-application/app-listing',
                                state: {
                                    ...history.location.state,
                                },
                            })
                        }}
                    >
                        <span className='indicator-label'>Save Changes</span>

                    </button>
                    <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn'
                        onClick={deleteScreenHandler}
                    >
                        <span className='indicator-label ' style={{ border: "1px solid red", color: "red", padding: "8px 16px", borderRadius: "18px" }}>Unlink</span>
                    </button>
                    {/* <div className="line"></div> */}
                    {/* <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn '
                        style={{ background: "green", color: "#fff" }}
                    >
                        <span className='indicator-label'>Submit for Review</span>

                    </button> */}
                </div>

            </div>
            <div className="add-screens-container">
                {allFlow?.length === 0 ? <h2 style={{ textAlign: "center", marginTop: "3rem" }}>No Flows Added</h2> : isSuccess === false && <h2 style={{ textAlign: "center", marginTop: "3rem" }}>Flow Unlinked</h2>}
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="cards" direction="horizontal">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} className="screens-container">
                                <>
                                    {flowDetail?.map((screen, screenIndex) => (
                                        <div key={screen._id}>
                                            <Draggable key={screen._id} draggableId={screen._id} index={screenIndex}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <ScreenCard
                                                            key={screen._id}
                                                            id={screen._id}
                                                            img={screen.image}
                                                            onSelect={() => handleScreenSelect(screen._id)}
                                                            isSelected={selectedFlow.includes(screen._id)}
                                                        />
                                                    </div>
                                                )}
                                            </Draggable>
                                        </div>
                                    ))}
                                </>
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>


            <CreateFlowDialog open={createFlowDialogOpen} onClose={handleCloseCreateFlowDialog} />
        </>

    )
}

export default FlowManager